import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MiscPartTimeEmployee } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class MiscPartTimeEmployeeService extends InfrastructureService<MiscPartTimeEmployee> {
  protected readonly endpoint: string = '/MiscPartTimeEmployees';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
